export default __webpack_public_path__ + "static/media/ourcampus.40f9262b.png";